import React, { useEffect, useRef, useState } from 'react';
import { Box, BoxProps } from '@mui/material';
import { animationClasses } from '../theme/animations';

export type AnimationType = 
  | 'fadeIn' 
  | 'fadeInUp' 
  | 'fadeInDown' 
  | 'fadeInLeft' 
  | 'fadeInRight' 
  | 'scaleIn' 
  | 'pulse' 
  | 'bounce'
  | 'none';

interface AnimatedBoxProps extends BoxProps {
  animation?: AnimationType;
  delay?: number;
  staggerIndex?: number;
  staggerDelay?: number;
  triggerOnScroll?: boolean;
  threshold?: number;
  once?: boolean;
}

export default function AnimatedBox({
  animation = 'none', // INSTANT MODE: Default to no animation
  delay = 0,
  staggerIndex,
  staggerDelay = 0, // INSTANT MODE: No stagger delay
  triggerOnScroll = false,
  threshold = 0.1,
  once = true,
  children,
  sx,
  ...props
}: AnimatedBoxProps) {
  // INSTANT MODE: Always render immediately, no intersection observer
  // Animations are disabled for speed - content appears instantly

  // Just render the content immediately without any animation
  return (
    <Box
      sx={{
        opacity: 1, // Always visible
        ...sx,
      }}
      {...props}
    >
      {children}
    </Box>
  );
}